import { render } from "./performance-goals.vue?vue&type=template&id=ddcf7db8"
import script from "./performance-goals.vue?vue&type=script&lang=js"
export * from "./performance-goals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__